
import { InsertDriveFile as InsertDriveFileIcon } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';

import InvoiceStat from './InvoiceStat';

interface OutstandingInvoicesProps {
    invoices?: [];
}

const OutstandingInvoices = ({ invoices }: OutstandingInvoicesProps) => {
    const totalInvoices = invoices?.length;

    const totalInvoicesAmount = invoices?.reduce((acc, curr) => {return acc + curr.totalInvoiceAmount;}, 0);

    return (
        <Grid
            sx={{
                padding: '0 24px',
                display: 'flex',
                flexDirection: 'row',
            }}
            gap={5}
            item
        >
            <Typography sx={{ fontSize: '21px', fontWeight: 500, color: '#1D1D1B' }}>
                Outstanding Invoices
            </Typography>
            <Grid
                item
                container
                gap={2}
                sx={{ borderLeft: '1px solid #FDC800', padding: '0 24px' }}
            >
                <InvoiceStat
                    label="Total Invoices"
                    icon={<InsertDriveFileIcon sx={{ color: '#FDC800' }} />}
                    value={totalInvoices}
                />
                <InvoiceStat
                    label="Total Invoices Amount"
                    value={totalInvoicesAmount}
                />
            </Grid>
        </Grid>
    );
};

export default OutstandingInvoices;
